import './open-drawer.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Withdrawal } from '@shared/app/scripts/services/withdrawal';

/*
 * Component responsible for /open-drawer route.
 *
 * The Open Cash Drawer is a 0 sales transaction for the purpose of recording
 * when the cash drawer is open and who opened it.
 */
angular
  .module('posApp')
  .directive(
    'openDrawer',
    (
      displayMessage: DisplayMessage,
      navigateTo: NavigateTo,
      pos,
      posReasons,
      sendWithdrawal,
      withdrawal: Withdrawal,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./open-drawer.html').default,

      link: function ($scope) {
        $scope.openDrawerReasons = posReasons.openDrawer;

        $scope.withdrawalreason = posReasons.openDrawer[0];

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.saveWithdrawal = () => {
          // Set this flag in order to block the UI
          $scope.processingRequest = true;

          displayMessage.showLoading();

          withdrawal.startNew().then((transaction) => {
            pos.setCashier(transaction, pos.config.selectedCashier);
            pos.setDate(transaction);

            transaction.withdrawelreason = $scope.withdrawalreason;

            sendWithdrawal(transaction);
          });
        };

        $scope.cancelOpenDrawer = () => {
          $scope.openDrawerEntryForm.$setPristine();
          navigateTo('pos.route#more');
        };
      },
    }),
  );
